import * as React from "react";
import {Header} from "../components/Header";

export const KulvrutantSamiti = () => {
    return (
        <>
            <div>
                <Header/>
            </div>
            <div className="mt-[72px] flex items-center justify-center">
                <img
                    src="/other_imgs/kulvruttant-samiti.png"
                    alt="Kulvruttant Samiti" className="landscape:w-1/2 portrait:w-full h-2/3 mt-10"
                />
            </div>
        </>
    );
};
